const actionType = {
  GET: "GET_AUTH",
  SET_KTP: "SET_KTP",
  SET_SELFIE: "SET_SELFIE",
  SET_SELFIE_KTP: "SET_SELFIE_KTP",
  UPDATE: "UPDATE_AUTH",
  DELETE: "DELETE_AUTH",
};

export default actionType;
